export const SAGE_CUSTOMER_CODE_HELPER =
  'Required for Sage invoicing. Use the customer code from Sage, for example VET004.';

export const SAGE_CUSTOMER_CODE_MISSING_WARNING =
  'No Sage customer code. Invoices for this company will fail.';

/** Null, missing, or whitespace-only codes are unmapped. A real code such as "0" is kept. */
export function isBlankSageCustomerCode(code: unknown): boolean {
  if (code == null) return true;
  return String(code).trim() === '';
}

/** Trimmed customer code for the create/edit body. Empty string clears the link. */
export function sageCustomerCodeForApi(value: unknown): string {
  if (value == null) return '';
  return String(value).trim();
}

/** Code on a company from GET. The API may send sage_customer_code or sageCustomerCode. */
export function readSageCustomerCode(source: object | null | undefined): string {
  if (!source) return '';
  const record = source as { sage_customer_code?: unknown; sageCustomerCode?: unknown };
  return sageCustomerCodeForApi(record.sage_customer_code ?? record.sageCustomerCode);
}
